module.exports = __webpack_public_path__ + "static/img/8.56b8b446.png";